import(/* webpackMode: "eager" */ "/vercel/path0/app/projects/SistemaFinanciero/page.tsx");
